import Typography from '../Typography';
import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

const FontSizeByLevel = [0, 40, 32, 28, 24, 20];
const LineHeightByLevel = [0, 52, 44, 40, 32, 28];

const Title = styled(Typography.Title)`
  && {
    font-size: ${({ level = 4 }) => `${FontSizeByLevel[level]}px`};
    font-style: normal;
    font-weight: 600;
    line-height: ${({ level = 4 }) => `${LineHeightByLevel[level]}px`};
    color: ${colors.gray900};
  }
`;

export default Title;
